import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyWhatsApp } from "@/components/StickyWhatsApp";

/**
 * Layout comune a tutte le pagine.
 * - Navbar fissa in alto
 * - Footer in basso
 * - Scroll-to-top automatico al cambio rotta
 * - `transparentHeader`: se true (es. Home con Hero), non aggiunge il padding
 *   sotto la navbar perché la sezione Hero ha già il proprio spazio.
 */
export const Layout = ({ children, transparentHeader = false }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="relative" data-testid="page-layout">
      <Navbar />
      <main className={transparentHeader ? "" : "pt-24 sm:pt-28"}>
        {children}
      </main>
      <Footer />
      <StickyWhatsApp />
    </div>
  );
};
